import {paperInfo} from '../model'
// import _ from 'lodash';
// Action about papers data

export interface InitPapersAction {
    type: "INIT_PAPERS";
    initialState: Array<paperInfo>;
}

export const initPapers = (initialState: Array<paperInfo>): InitPapersAction => ({
    type: "INIT_PAPERS",
    initialState,
});

export type PapersAction = InitPapersAction;


export interface SetSelectedPapersAction {
    type: "SET_SELECTED_PAPERS";
    newState: Array<number>;
}

export const setSelectedPapers = (newState: Array<number>): SetSelectedPapersAction => ({
    type: "SET_SELECTED_PAPERS",
    newState,
});

export type SelectedPapersAction = SetSelectedPapersAction;
